import { observable, action, computed } from "mobx";
import { post } from "../services/ajax.service";

class ReportBookStore {





  @observable reports = [];
  @observable daw_review = [];
  @observable daw_review_code = {};
  @observable duplicate_participants_count = 0;
  @observable duplicate_participants_cost = 0;
  @observable duplicate_participants = [];
  @observable recent = false;
  @observable action = false;
  @observable errors = {};
  @observable total_employees = 0;
  @observable total_participants = 0;
  @observable total_spend = 0;
  @observable total_lives = 0;
  @observable average_claim_cost = 0;
  @observable current_month_spend = 0;
  @observable previous_month_spend = 0;
  @observable current_month_plan_spend = 0;
  @observable previous_month_plan_spend = 0;
  @observable pmpm = 0;
  @observable maintenanceMedications = {
    current_month: [], previous_month: []
  };
  @observable plan_spend_monthly = [];
  @observable url = "/api/v1/reportBookActions";
  @observable drug_type_info = {
    brand: {},
    specialty: {},
    generic: {}
  };
  @observable topfiveDrugs = [];
  @observable topfiveClaims = [];
  @observable ineligibleParticipantCount = 0;
  @observable ineligibleSpend = 0;
  @observable duplicate_count = 0;
  @observable duplicate_cost = 0;
  @observable duplicates = [];
  @observable duplicates_eligibilty_review = [];
  @observable highDrugCost = [];
  @observable previous_month_prescriptions = 0;
  @observable current_month_prescriptions = 0;
  @observable dawReview = [];
  @observable NoCopayClaimsCount = 0;
  @observable NoCopayClaimCost = 0;
  @observable NoCopayDrugCount = 0;
  @observable PcmSavingsData = {};
  @observable RxTourismData = {};
  @observable AlternateFundingData = {};
  @observable InternationalRxData = {};
  @observable PrecisionPgxData = {};
  @observable SpecialtyCarveOutData = {};
  @observable RxValetPapData = {};
  @observable RxValetPapListData = [];
  @observable RxValetInternationalData = {};
  @observable RxValetInternationalListData = [];
  @observable total_claims = 0;
  @observable total_missing_life_id = [];
  @observable TopthreeOpioidPharmacies = [];
  @observable TopthreeOpioidPhysicians = [];
  @observable TopthreeOpioidDrugs = [];
  @observable PBM = [];
  @observable MarketCheckSavingsByCategories = [];
  @observable current_market_check_pmpm = 0;
  @observable new_market_check_pmpm = 0;
  @observable in_progress = 0;
  @observable physician_denied = 0;
  @observable participant_denied = 0;
  @observable physician_approved = 0;
  @observable participant_approved = 0;
  @observable cost_containment_savings = [];
  @observable current_quarter_savings = 0;
  @observable previous_six_month_savings = 0;
  @observable recent_twelve_month_savings = 0;
  @observable inception_savings = 0;
  @observable therapeutic_break_down_savings = [];
  @observable participant_communications = 0;
  @observable therapeutic_break_down_savings_two = [];
  @observable physician_approved_break_down = {};
  @observable physician_denied_break_down = {};
  @observable participant_approved_break_down = {};
  @observable participant_denied_break_down = {};
  @observable top_three_approved_by_physicians = [];
  @observable top_three_denied_by_physicians = [];
  @observable top_three_approved_by_participants = [];
  @observable top_three_denied_by_participants = [];
  @observable NoCopayParticipants = [];
  @observable benzoUseTopDrugsRxFilled = [];
  @observable benzoUseTopProvidersRxFilled = [];
  @observable benzoUseTopPharmaciesRxFilled = [];
  @observable opioidUseTopDrugsRxFilled = [];
  @observable opioidUseTopProvidersRxFilled = [];
  @observable opioidUseTopPharmaciesRxFilled = [];
  @observable AlternativeFunding_Information = { drug_list: [], alternative_funding_cost: 0, drug_cost: 0 };
  @observable InternationalRx_Information = { drug_list: [], savings: 0, drug_cost: 0 };
  @observable PcmSavings_Information = { drug_list: [], therapeutic_list: [] };
  @observable PrecisionPgx_Information = { drug_list: [], drug_count: 0, total_participants: 0, total_spend: 0 };
  @observable RebateManagement_Information = [];
  @observable RxTourism_Information = { drug_list: [], rx_tourism_cost: 0, drug_cost: 0 };
  @observable SpecialtyCarveOut_Information = { drug_list: [], drug_count: 0, total_participants: 0, total_spend: 0 };



  //Analysis-Report-New-Design-Observables

  @observable participant_savings = [];
  @observable drug_count_af = 0;
  @observable unique_par_af = 0;
  @observable drug_count_ir = 0;
  @observable unique_par_ir = 0;
  @observable drug_count_pgx = 0;
  @observable unique_par_pgx = 0;
  @observable drug_count_rx = 0;
  @observable unique_par_rx = 0;
  @observable drug_count_s = 0;
  @observable unique_par_s = 0;
  @observable precisionpgx_cost = 0;
  @observable specialty_cost = 0;
  @observable international_total_spend = 0;
  @observable international_rx_spend = 0;
  @observable af_total_spend = 0;
  @observable af_rx_spend = 0;
  @observable rx_total_spend = 0;
  @observable rx_spend = 0;
  @observable drug_spend_internationalRx = [];
  @observable top_five_participants_s = [];
  @observable top_five_participants_pgx = [];
  @observable current_formulary_rebate = 0;
  @observable current_formulary_drugs = [];
  @observable optimized_formulary_alt_rebate = 0;
  @observable optimized_formulary_total_saving = 0;
  @observable optimized_formulary_drugs = [];
  @observable total_savings_lives = [];
  @observable teleHealthCard = {}





  //Common-Recommendation-Observables
  //PCM Savings Observables
  @observable claims_count = 0;
  @observable life_count = 0;
  @observable employee_count = 0;
  @observable current_drug_cost = 0;
  @observable proposed_drug_cost = 0;
  @observable alternatives = 0;
  @observable claim_cost = 0;
  @observable drug_count = 0;
  @observable max_saving = 0;
  @observable participant_count = 0;
  @observable min_date = ""
  @observable max_date = ""
  @observable participant_savings = [];
  @observable average_therapeutic_savings = [];

  //Finished PCM Savings Observables

  @action setErrors = () => {
    this.errors = {};
  };

  @action setAction = action => {
    this.action = action;
  };




  //Common-Recommendation-Store
  //PCM Savings Methods

  @action getMaxSavings = async data => {
    this.max_saving = 0;
    try {
      let response = await post(
        `${this.url}/getMaxSavings`,
        data
      );
      this.max_saving = response.data[0].MAXIMUM_SAVINGS || 0;
      this.participant_count = response.data[0].unique_par || 0
      this.drug_count = response.data[0].drug_count || 0
      this.min_date = response.data[0].min_date || ""
      this.max_date = response.data[0].max_date || ""
    } catch (err) {
      console.log(err);
    }
  };


  @action getCurrentDrugCost = async data => {
    this.current_drug_cost = 0;
    try {
      let response = await post(
        `${this.url}/getCurrentDrugCost`,
        data
      );

      this.current_drug_cost = response.data[0].CURRENT_DRUG_COST;
      this.claim_cost = response.data[0].claim_cost;
      this.alternatives = response.data[0].alternatives;
    } catch (err) {
      console.log(err);
    }
  };

  @action getProposedDrugCost = async data => {
    this.proposed_drug_cost = 0;
    try {
      let response = await post(
        `${this.url}/getProposedDrugCost`,
        data
      );

      this.proposed_drug_cost = response.data[0].PROPOSED_DRUG_COST;
    } catch (err) {
      console.log(err);
    }
  };

  @action getLifeCount = async data => {
    this.life_count = 0;
    try {
      let response = await post(
        `${this.url}/getLifeCount`,
        data
      );

      this.life_count = response.data[0].LIFE_COUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getEmployeeCount = async data => {
    this.employee_count = 0;
    try {
      let response = await post(
        `${this.url}/getEmployeeCount`,
        data
      );

      this.employee_count = response.data[0].EMPLOYEE_COUNT;
    } catch (err) {
      console.log(err);
    }
  };

  @action getTotalClaim = async data => {
    this.claims_count = 0;
    try {
      let response = await post(
        `${this.url}/getTotalClaim`,
        data
      );
      this.claims_count = response.data[0].TOTAL_CLAIMS;
    } catch (err) {
      console.log(err);
    }
  };

  @action getParticipantSavings = async data => {
    this.participant_savings = [];
    try {
      let response = await post(
        `${this.url}/getParticipantSavings`,
        data
      );
      this.participant_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };


  @action getAverageTherapeuticSavings = async data => {
    this.average_therapeutic_savings = [];
    try {
      let response = await post(
        `${this.url}/getAverageTherapeuticSavings`,
        data
      );

      this.average_therapeutic_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  //Finished PCM Savings Methods























  //Analysis-Report-New-Design-Store-Actions

  @action getParticipantSavings = async data => {
    this.participant_savings = [];
    try {
      let response = await post(
        `${this.url}/getParticipantSavings`,
        data
      );
      this.participant_savings = response.data;
    } catch (err) {
      console.log(err);
    }
  };

  @action getDrugCountAlternateFunding = async (data) => {
    this.drug_count_af = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCountAlternateFunding`,
        data
      );

      this.drug_count_af = response.data[0].drug_count;
      this.unique_par_af = response.data[0].unique_par;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugCountInternationalRX = async (data) => {
    this.drug_count_ir = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCountInternationalRX`,
        data
      );
      this.drug_count_ir = response.data[0].drug_count;
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxValetPap = async (data) => {
    this.RxValetPapData = 0;
    try {
      let response = await post(
        `${this.url}/getRxValetPap`,
        data
      );
      this.RxValetPapData = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxValetPapList = async (data) => {
    this.RxValetPapListData = 0;
    try {
      let response = await post(
        `${this.url}/getRxValetPapList`,
        data
      );
      this.RxValetPapListData = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxValetInternational = async (data) => {
    this.RxValetInternationalData = 0;
    try {
      let response = await post(
        `${this.url}/getRxValetInternational`,
        data
      );
      this.RxValetInternationalData = response.data[0];
    } catch (err) {
      console.log(err);
    }
  }

  @action getRxValetInternationalList = async (data) => {
    this.RxValetInternationalListData = 0;
    try {
      let response = await post(
        `${this.url}/getRxValetInternationalList`,
        data
      );
      this.RxValetInternationalListData = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getTotalParticipantsInternationalRx = async (data) => {
    this.unique_par_ir = 0;
    try {
      let response = await post(
        `${this.url}/getTotalParticipantsInternationalRx`,
        data
      );

      this.unique_par_ir = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugCountPGX = async (data) => {
    this.drug_count_pgx = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCountPGX`,
        data
      );
      this.drug_count_pgx = (new Set(response.data[0].drug_count.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
      this.unique_par_pgx = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }

  @action getDrugCountRxTourism = async (data) => {
    this.drug_count_rx = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCountRxTourism`,
        data
      );
      this.drug_count_rx = (new Set(response.data[0].drug_count.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
      this.unique_par_rx = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }
  @action getDrugCountSpecialtyCarveOut = async (data) => {
    this.drug_count_s = 0;
    try {
      let response = await post(
        `${this.url}/getDrugCountSpecialtyCarveOut`,
        data
      );
      this.drug_count_s = (new Set(response.data[0].drug_count.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
      this.unique_par_s = (new Set(response.data[0].unique_par.replace(/,\s*$/, "").split(",").filter(a => a != ""))).size;
    } catch (err) {
      console.log(err);
    }
  }

  @action getInternationalDrugSpendReport = async (data) => {
    this.drug_spend_internationalRx = [];
    try {
      let response = await post(
        `${this.url}/getInternationalDrugSpendReport`,
        data
      );

      this.drug_spend_internationalRx = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action Get_Specialty_Carve_Out_Participants = async (data) => {
    this.top_five_participants_s = [];
    try {
      let response = await post(
        `${this.url}/Get_Specialty_Carve_Out_Participants`,
        data
      );
      this.top_five_participants_s = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action Get_PGX_Participants = async (data) => {
    this.top_five_participants_pgx = [];
    try {
      let response = await post(
        `${this.url}/Get_PGX_Participants`,
        data
      );
      this.top_five_participants_pgx = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getCurrentFormulary = async (data) => {
    try {
      this.current_formulary_rebate = 0;
      let response = await post(
        `${this.url}/getCurrentFormulary`,
        data
      );

      this.current_formulary_rebate = response.data[0].total_rebates;

    } catch (err) {
      console.log(err);
    }
  }

  @action getCurrentFormularyDrugs = async (data) => {
    try {
      this.current_formulary_drugs = [];
      let response = await post(
        `${this.url}/getCurrentFormularyDrugs`,
        data
      );

      this.current_formulary_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  }


  @action getOptimizedFormulary = async (data) => {
    try {

      this.optimized_formulary_alt_rebate = 0;
      this.optimized_formulary_total_saving = 0;

      let response = await post(
        `${this.url}/getOptimizedFormulary`,
        data
      );

      this.optimized_formulary_alt_rebate = response.data[0].total_alt_rebates;
      this.optimized_formulary_total_saving = response.data[0].Total_Savings;

    } catch (err) {
      console.log(err);
    }
  }

  @action getOptimizedFormularyDrugs = async (data) => {
    try {
      this.optimized_formulary_drugs = [];
      let response = await post(
        `${this.url}/getOptimizedFormularyDrugs`,
        data
      );

      this.optimized_formulary_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getSavingsTotalLivesAffected = async (data) => {
    try {
      this.total_savings_lives = [];
      let response = await post(
        `${this.url}/getSavingsTotalLivesAffected`,
        data
      );

      this.total_savings_lives = response.data[0].total_savings_lives;
    } catch (err) {
      console.log(err);
    }
  }



  @action getAlternativeFundingInformation = async data => {
    this.af_total_spend = 0;
    this.af_rx_spend = 0
    const response = await post(
      `${this.url}/getAlternativeFundingInformation`, data
    );
    this.AlternativeFunding_Information = response.data;
    this.af_rx_spend = response.data.drug_cost[0].RX_TOURISM_SPEND;
    this.af_total_spend = response.data.savings[0].TARGET_SPEND;

    console.log(JSON.parse(JSON.stringify(this.af_total_spend)), "Store af");
  }

  @action getInternationalRxInformation = async data => {
    this.international_total_spend = 0;
    this.international_rx_spend = 0
    const response = await post(
      `${this.url}/getInternationalRxInformation`, data
    );
    this.InternationalRx_Information = response.data;
    this.international_total_spend = response.data.drug_cost[0].TARGET_SPEND;
    this.international_rx_spend = response.data.savings[0].RX_TOURISM_SPEND;
  }

  @action getPcmSavingsInformation = async data => {
    const response = await post(
      `${this.url}/getPcmSavingsInformation`, data
    );
    this.PcmSavings_Information = response.data;
  }

  @action getPrecisionPgxInformation = async data => {
    this.precisionpgx_cost = 0
    const response = await post(
      `${this.url}/getPrecisionPgxInformation`, data
    );
    this.PrecisionPgx_Information = response.data;
    this.precisionpgx_cost = response.data.total_spend[0].claim_cost
  }

  @action getRebateManagementInformation = async data => {
    const response = await post(
      `${this.url}/getRebateManagementInformation`, data
    );
    this.RebateManagement_Information = response.data;
  }

  @action getRxTourismInformation = async data => {
    this.rx_spend = 0;
    this.rx_total_spend = 0
    const response = await post(
      `${this.url}/getRxTourismInformation`, data
    );
    this.RxTourism_Information = response?.data;
    this.rx_spend = response.data.drug_cost[0]?.TARGET_SPEND;
    this.rx_total_spend = response.data.savings[0]?.RX_TOURISM_SPEND;
  }

  getLength=(data)=>{
    if(!data){
        return 0;
    }
    const inputArray = data.split(',');
    // Use a Set to remove duplicate values
    const uniqueArray = [...new Set(inputArray.filter(Boolean))];
    // Get the length and unique values
    return uniqueArray.length;
  }
  @action getInternationalTelehealth = async data => {
    this.teleHealthCard = {};
    const response = await post(
      `${this.url}/getInternationalTelehealth`, data
    );
    let tempData = response.data;
    tempData.participant_count=this.getLength(tempData.drug_cost[0].participant_count);
    tempData.drugs_count=this.getLength(tempData.drug_cost[0].drugs_count);
    tempData.potential_spend=tempData.drug_cost[0].potential_spend
    tempData.current_spend=tempData.drug_cost[0].current_spend
    tempData.available_savings=tempData.drug_cost[0].available_savings
    this.teleHealthCard=tempData;
  }

  @action getSpecialtyCarveOutInformation = async data => {
    this.specialty_cost = 0
    const response = await post(
      `${this.url}/getSpecialtyCarveOutInformation`, data
    );
    this.SpecialtyCarveOut_Information = response.data;
    this.specialty_cost = response.data.total_spend[0].claim_cost
  }


  @action getTotalParticipants = async data => {
    const response = await post(
      `${this.url}/getTotalParticipants`, data
    );
    this.total_participants = response.data[0].participant_count;
  }

  @action getTotalSpend = async data => {
    const response = await post(
      `${this.url}/getTotalSpend`, data
    );
    this.total_spend = response.data[0].total_spend;
  }

  @action getTotalLives = async data => {
    const response = await post(
      `${this.url}/getTotalLives`, data
    );
    this.total_lives = response.data[0].life_count;
  }

  @action getTotalEmployees = async data => {
    const response = await post(
      `${this.url}/getTotalEmployees`, data
    );
    this.total_employees = response.data[0].employee_count;
  }

  @action getAverageClaimCost = async data => {
    const response = await post(
      `${this.url}/getAverageClaimCost`, data
    );
    this.average_claim_cost = response.data[0].avg_claim_cost;
  }

  @action getCurrentMonthSpend = async data => {
    const entityData = await post(
      `${this.url}/getCurrentMonthSpend`, data
    );
    this.reports = entityData.data.rows;
  }

  @action getPreviousMonthSpend = async data => {
    const response = await post(
      `${this.url}/getPreviousMonthSpend`, data
    );
    this.previous_month_spend = response.data[0].previous_month_spend;
    this.current_month_spend = response.data[0].current_month_spend;
  }

  @action getPMPM = async data => {
    const response = await post(
      `${this.url}/getPMPM`, data
    );
    this.pmpm = response.data[0].PMPM;
  }

  @action getMaintenanceMedications = async data => {
    const response = await post(
      `${this.url}/getMaintenanceMedications`, data
    );
    this.maintenanceMedications.current_month = response.data.CURRENT_MONTH;
    this.maintenanceMedications.previous_month = response.data.PREVIOUS_MONTH;
  }

  @action getMonthlyPlanSpend = async data => {
    const response = await post(
      `${this.url}/getMonthlyPlanSpend`, data
    );
    this.plan_spend_monthly = response.data;
    this.recent = response?.data[0]?.recent ?? false;
  }

  @action getDrugTypeInfo = async data => {
    const response = await post(
      `${this.url}/getDrugTypeInfo`, data
    );
    this.drug_type_info.brand = response.data.brand[0];
    this.drug_type_info.generic = response.data.generic[0];
    this.drug_type_info.specialty = response.data.specialty[0];

  }

  @action getTopFiveDrugs = async data => {
    const response = await post(
      `${this.url}/getTopFiveDrugs`, data
    );
    this.topfiveDrugs = response.data;
  }

  @action getTopFiveClaims = async data => {
    const response = await post(
      `${this.url}/getTopFiveClaims`, data
    );
    this.topfiveClaims = response.data;
  }

  @action getIneligibleParticipantCount = async data => {
    const response = await post(
      `${this.url}/getIneligibleParticipantCount`, data
    );
    this.ineligibleParticipantCount = response.data[0].participant_count;
  }

  @action getTotalIneligibleSpend = async data => {
    const response = await post(
      `${this.url}/getTotalIneligibleSpend`, data
    );
    this.ineligibleSpend = response.data[0].total_spend;
  }

  @action getDuplicateCount = async data => {
    const response = await post(
      `${this.url}/getDuplicateCount`, data
    );
    this.duplicate_count = response.data[0].duplicate_count;
  }

  @action getDuplicateCost = async data => {
    const response = await post(
      `${this.url}/getDuplicateCost`, data
    );
    this.duplicate_cost = response.data[0].total_duplicate_cost;
  }

  @action getDuplicates = async data => {
    const response = await post(
      `${this.url}/getDuplicates`, data
    );
    this.duplicates = response.data.sort((a, b) => (a.last_name > b.last_name) ? 1 : ((b.last_name > a.last_name) ? -1 : 0));

    let count = this.duplicates.length;
    let loop_index = 0;
    if (count <= 26) {
      this.duplicates_eligibilty_review.push({ index0: this.duplicates })
    }
    else {
      this.duplicates_eligibilty_review.push({ index0: this.duplicates.slice(0, 26) })
      loop_index = parseInt((count - 26) / 30);
      let start_index = 26;
      let end_index = 56;
      for (var i = 0; i <= loop_index; i++) {
        this.duplicates_eligibilty_review.push({ [`index${i + 1}`]: this.duplicates.slice(start_index, end_index) })
        start_index += 30;
        end_index += 30;
      }
    }

  }

  @action getNewHighCostDrugs = async data => {
    const response = await post(
      `${this.url}/getNewHighCostDrugs`, data
    );
    this.highDrugCost = response.data;
  }

  @action getHighCostDifference = async data => {
    const response = await post(
      `${this.url}/getHighCostDifference`, data
    );
    this.previous_month_plan_spend = response.data[0].previous_month_spend;
    this.current_month_plan_spend = response.data[0].current_month_spend;
    // this.previous_month_prescriptions = response.data[0].previous_claims_count;
    // this.current_month_prescriptions = response.data[0].current_claims_count
  }

  @action getDawReview = async data => {
    const response = await post(
      `${this.url}/getDawReview`, data
    );
    this.dawReview = response.data;
  }

  @action getNoCopayClaimsCount = async data => {
    const response = await post(
      `${this.url}/getNoCopayClaimsCount`, data
    );
    this.NoCopayClaimsCount = response.data[0].claims_count;
    this.NoCopayClaimCost = response.data[0].COST;
  }
  @action getNoCopayParticipants = async data => {
    const response = await post(
      `${this.url}/getNoCopayParticipants`, data
    );
    this.NoCopayParticipants = response.data
  }



  @action getNoCopayDrugCount = async data => {
    const response = await post(
      `${this.url}/getNoCopayDrugCount`, data
    );
    this.NoCopayDrugCount = response.data[0].drug_count;
  }

  @action getPcmSavingsData = async data => {
    const response = await post(
      `${this.url}/getPcmSavingsData`, data
    );
    this.PcmSavingsData = response.data[0];
  }

  @action getMarketCheckData = async data => {
    const response = await post(
      `${this.url}/getMarketCheckData`, data
    );
    this.PcmSavingsData = response.data[0];
  }

  @action getRxTourismData = async data => {
    const response = await post(
      `${this.url}/getRxTourismData`, data
    );
    this.RxTourismData = response.data[0];
  }

  @action getAlternateFundingData = async data => {
    const response = await post(
      `${this.url}/getAlternateFundingData`, data
    );
    this.AlternateFundingData = response.data[0];
  }

  @action getInternationalRxData = async data => {
    const response = await post(
      `${this.url}/getInternationalRxData`, data
    );
    this.InternationalRxData = response.data[0];
  }

  @action getPrecisionPgxData = async data => {
    const response = await post(
      `${this.url}/getPrecisionPgxData`, data
    );
    this.PrecisionPgxData = response.data[0];
  }

  @action getSpecialtyCarveOutData = async data => {
    const response = await post(
      `${this.url}/getSpecialtyCarveOutData`, data
    );
    this.SpecialtyCarveOutData = response.data[0];
  }

  @action getTotalClaims = async data => {
    const response = await post(
      `${this.url}/getTotalClaims`, data
    );
    this.total_claims = response.data[0].total_claims;
  }

  @action getTotalMissingLifeId = async data => {
    const response = await post(
      `${this.url}/getTotalMissingLifeId`, data
    );
    this.total_missing_life_id = response.data;
  }

  @action getTopthreeOpioidPharmacies = async data => {
    const response = await post(
      `${this.url}/getTopthreeOpioidPharmacies`, data
    );
    this.TopthreeOpioidPharmacies = response.data;
  }

  @action getTopthreeOpioidPhysicians = async data => {
    const response = await post(
      `${this.url}/getTopthreeOpioidPhysicians`, data
    );
    this.TopthreeOpioidPhysicians = response.data;
  }

  @action getTopthreeOpioidDrugs = async data => {
    const response = await post(
      `${this.url}/getTopthreeOpioidDrugs`, data
    );
    this.TopthreeOpioidDrugs = response.data;
  }

  @action getInProgress = async data => {
    const response = await post(
      `${this.url}/getInProgress`, data
    );
    this.in_progress = response.data[0].count;
  }

  @action getParticipantApproved = async data => {
    const response = await post(
      `${this.url}/getParticipantApproved`, data
    );
    this.participant_approved = response.data[0].count;
  }

  @action getPhysicianApproved = async data => {
    const response = await post(
      `${this.url}/getPhysicianApproved`, data
    );
    this.physician_approved = response.data[0].count;
  }

  @action getParticipantDenied = async data => {
    const response = await post(
      `${this.url}/getParticipantDenied`, data
    );
    this.participant_denied = response.data[0].count;
  }

  @action getPhysicianDenied = async data => {
    const response = await post(
      `${this.url}/getPhysicianDenied`, data
    );
    this.physician_denied = response.data[0].count;
  }

  @action getCostContainmentSavings = async data => {
    const response = await post(
      `${this.url}/getCostContainmentSavings`, data
    );
    this.cost_containment_savings = response.data;
    this.recent = response?.data[0]?.recent ?? false;
  }

  @action getCurrentQuarterSavings = async data => {
    const response = await post(
      `${this.url}/getCurrentQuarterSavings`, data
    );
    this.current_quarter_savings = response.data[0].current_quarter_savings;
  }

  @action getPreviousSixMonthSavings = async data => {
    const response = await post(
      `${this.url}/getPreviousSixMonthSavings`, data
    );
    this.previous_six_month_savings = response.data[0].previous_6_month_savings;
  }


  @action getRecentTwelveMonthSavings = async data => {
    const response = await post(
      `${this.url}/getRecentTwelveMonthSavings`, data
    );
    this.recent_twelve_month_savings = response.data[0].recent_12_month_savings;
  }

  @action getInceptionSavings = async data => {
    const response = await post(
      `${this.url}/getInceptionSavings`, data
    );
    this.inception_savings = response.data[0].inception_savings;
  }

  @action getTherapeuticClassBreakDownAndSavings = async data => {
    const response = await post(
      `${this.url}/getTherapeuticClassBreakDownAndSavings`, data
    );
    this.therapeutic_break_down_savings = response.data;
  }


  @action getParticipantCommunications = async data => {
    const response = await post(
      `${this.url}/getParticipantCommunications`, data
    );
    this.participant_communications = response.data[0].communication_count;
  }

  @action getTherapeuticClassBreakDownAndSavingsTwo = async data => {
    const response = await post(
      `${this.url}/getTherapeuticClassBreakDownAndSavingsTwo`, data
    );
    this.therapeutic_break_down_savings_two = response.data;
  }

  @action getPhysicianApprovedBreakDown = async data => {
    const response = await post(
      `${this.url}/getPhysicianApprovedBreakDown`, data
    );
    this.physician_approved_break_down = response.data[0];
  }

  @action getPhysicianDeniedBreakDown = async data => {
    const response = await post(
      `${this.url}/getPhysicianDeniedBreakDown`, data
    );
    this.physician_denied_break_down = response.data[0];
  }

  @action getParticipantDeniedBreakDown = async data => {
    const response = await post(
      `${this.url}/getParticipantDeniedBreakDown`, data
    );
    this.participant_denied_break_down = response.data[0];
  }

  @action getParticipantApprovedBreakDown = async data => {
    const response = await post(
      `${this.url}/getParticipantApprovedBreakDown`, data
    );
    this.participant_approved_break_down = response.data[0];
  }


  @action getTopThreeApprovedByPhysicians = async data => {
    const response = await post(
      `${this.url}/getTopThreeApprovedByPhysicians`, data
    );
    this.top_three_approved_by_physicians = response.data;
  }

  @action getTopThreeDeniedByPhysicians = async data => {
    const response = await post(
      `${this.url}/getTopThreeDeniedByPhysicians`, data
    );
    this.top_three_denied_by_physicians = response.data;
  }

  @action getTopThreeApprovedByParticipants = async data => {
    const response = await post(
      `${this.url}/getTopThreeApprovedByParticipants`, data
    );
    this.top_three_approved_by_participants = response.data;
  }

  @action getTopThreeDeniedByParticipants = async data => {
    const response = await post(
      `${this.url}/getTopThreeDeniedByParticipants`, data
    );
    this.top_three_denied_by_participants = response.data;
  }

  @action getPBM = async data => {
    const response = await post(
      `${this.url}/getPBM`, data
    );

    if (response.data.length > 0) {
      for (let r of response.data) {
        const category_details = await post(`${this.url}/getMarketCheckSavingsByCategory`, { ...data, contract_id: r.contract_id });
        r["category_savings"] = category_details.data;
      }
    }
    this.PBM = response.data;
  }
  @action getMarketCheckSavingsByCategory = async data => {
    const response = await post(
      `${this.url}/getMarketCheckSavingsByCategory`, data
    );
    this.MarketCheckSavingsByCategories = response.data;
  }
  @action getMarketCheckPMPM = async data => {
    const response = await post(
      `${this.url}/getMarketCheckPMPM`, data
    );
    this.current_market_check_pmpm = response.data[0].current_pmpm;
    this.new_market_check_pmpm = response.data[0].new_pmpm;
  }

}

export default ReportBookStore;